import * as qs from 'qs'

export const eventListPageLocalityCategoriesUrl = () => {
  const params = qs.stringify({
    filter: 'id;permalink;title;slug;avg_review;total_reviews',
    search: 'featured:1',
    limit: '-1',
  })

  return `v1/store/locality-category?${params}`
}

export const eventListPageCategoryUrl = (opts: { categorySlug?: string }) => {
  const params = qs.stringify({
    include: 'thumbnail',
    filter: 'name;slug;thumbnail;avg_review;total_reviews',
  })

  return `/v1/store/categories${
    opts.categorySlug ? `/${opts.categorySlug}` : ''
  }?${params}`
}
export const eventListPageTagUrl = (opts: { tagSlug?: string }) => {
  const params = qs.stringify({
    filter: 'name;slug;avg_review;total_reviews',
  })

  return `/v1/store/tags/${opts.tagSlug}?${params}`
}

export const eventListPageLocalitiesUrl = (opts: {
  citySlug: string | undefined
}) => {
  const params = qs.stringify({
    filter: 'name;slug;avg_review;total_reviews',
    featured: 1,
  })

  return `v1/store/localities${
    opts.citySlug ? '/' + opts.citySlug : ''
  }?${params}`
}
